module.exports = __webpack_public_path__ + "static/img/godwealth_th.2384665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/godwealth_th.png
// module id = dewy
// module chunks = 1